module.exports = __webpack_public_path__ + "static/media/insta-4.4acd4126.png";